module.exports = __webpack_public_path__ + "static/prematuro1-6b1de864cb3ee175168075610bdcb2a8.jpg";